export default "__VITE_ASSET__CiBX5kYH__"